var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rexer_events__filters" }, [
    _c(
      "ul",
      { staticClass: "rexer_events__filters-wrap" },
      [
        _c("li", { staticClass: "rexer_events__filter filter_all" }, [
          _c(
            "a",
            {
              class: { active: "all" === _vm.filterItem },
              attrs: { title: _vm.title, href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.filterHandle("all")
                }
              }
            },
            [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
          )
        ]),
        _vm._v(" "),
        _vm._l(_vm.filters, function(item, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "rexer_events__filter",
              class: item.custom_class,
              attrs: { id: "filter-" + item.id }
            },
            [
              _c(
                "a",
                {
                  class: { active: "item.slug" === _vm.filterItem },
                  attrs: { title: item.name, href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.filterHandle(item)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]
              )
            ]
          )
        }),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "rexer_events__filter" },
          [
            _c("location-dropdown", {
              attrs: {
                locations: _vm.locationSorted,
                selection: _vm.locationsSelection
              }
            })
          ],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }